interface DrillsProps {
  onNavigate: (to: string) => void;
}

interface DrillEntry {
  slug: string;
  name: string;
  description: string;
}

const DRILLS: readonly DrillEntry[] = [
  {
    slug: "mob",
    name: "Man-overboard recovery",
    description:
      "Six standard manoeuvres — figure-of-eight, beam-reach return, Williamson, Anderson, Scharnow, quick-stop. Animated paths + step-by-step helmsman actions. Drill until automatic.",
  },
  {
    slug: "predeparture",
    name: "Pre-departure check",
    description:
      "Interactive checklist — safety kit, engine, electronics, navigation, boat condition, crew brief, paperwork. Progress persists across sessions; reset before each new passage.",
  },
];

/// Hub page for procedural exercises that aren't games — drills you
/// run through to build muscle memory + a working checklist for the
/// pre-departure walk-round. Distinct from Play (timed/scored games)
/// and Reference (catalogues + theory).
export function Drills({ onNavigate }: DrillsProps) {
  return (
    <>
      <h2 style={{ marginTop: 0 }}>Drills &amp; checklists</h2>
      <p className="muted">
        Procedural exercises — no scoring, no win/lose. Run through
        each one until the muscle memory's there, then come back
        before every passage.
      </p>
      {DRILLS.map((d) => (
        <div key={d.slug} className="card">
          <h2 style={{ marginBottom: 4 }}>{d.name}</h2>
          <p className="small muted" style={{ marginBottom: 12 }}>
            {d.description}
          </p>
          <button
            onClick={() => onNavigate(`/drills/${d.slug}`)}
            className="secondary"
          >
            Open
          </button>
        </div>
      ))}
    </>
  );
}
